import { useContext } from 'react';

import { HistogramColorPaletteContext } from '../contexts/HistogramColorPalette.context.js';

export const useHistogramColorPalette = () =>
  useContext(HistogramColorPaletteContext);
